import { contrastRatio } from '@yola/yola-palette-generator';
import isDark from '../../../../common/verifiers/is-dark';
import increaseColorPointByRatio from '../../../../common/utils/increase-color-point-by-ratio';
import reduceColorPointByRatio from '../../../../common/utils/reduce-color-point-by-ratio';

const primary = (params) => {
  const { targetColor, backgroundColor, targetColorPalette } = params;
  const fallback = {
    rule: 'input.borderColor.default.primary',
    params,
  };
  if (!isDark(backgroundColor)) {
    return increaseColorPointByRatio({
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.3,
      fallback,
    });
  }

  if (contrastRatio(backgroundColor, targetColorPalette[900]) >= 1.7) {
    return increaseColorPointByRatio({
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.7,
      fallback,
    });
  }

  return reduceColorPointByRatio({
    targetColor,
    backgroundColor,
    targetColorPalette,
    condition: (ratio) => ratio >= 1.7,
    fallback,
  });
};

export default primary;
